import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import AtIcon from "../../atoms/AtIcon";
import AtButton from "../../atoms/AtButton";
import classNames from "classnames";
import { useKey } from "react-use";
import {
  mainUiActions,
  pageViews,
  useUiDispatch,
  useUiState
} from "../../../reducers/mainui.reducer";
import Axios from "axios";
import AppProvider from "../../../api/appProvider";
import { designListActions, useDispatchDesignList } from "../../../reducers/designlist.reducer";

const SearchBar = props => {
  const {
    textToSearch,
    handleInputChange,
    placeholder,
    handleCancel,
    className,
    hidden,
    setLoading
  } = props;

  const dispatchUiState = useUiDispatch();
  const [focused, setFocused] = useState(false);
  const uiState = useUiState();
  const fileInputRef = useRef(null);
  const dispatchDesignList = useDispatchDesignList();
  const input = useRef();
  const onInputChange = e => {
    if (e.target.value.length) {
      setFocused(true);
    } else {
      setFocused(false);
    }
    handleInputChange(e);
  };
  useKey("Escape", () => {
    input.current.blur();
  });

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = e => {
    setLoading(true);
    const file = e.target.files[0];
    if (!file) return;

    const img = new Image();
    const reader = new FileReader();

    reader.onload = event => {
      img.src = event.target.result;

      img.onload = () => {
        const MAX_WIDTH = 800;
        const MAX_HEIGHT = 800;
        let width = img.width;
        let height = img.height;

        // Maintain aspect ratio
        if (width > height) {
          if (width > MAX_WIDTH) {
            height = (height * MAX_WIDTH) / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width = (width * MAX_HEIGHT) / height;
            height = MAX_HEIGHT;
          }
        }

        // Create canvas
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        // Convert canvas to same format as original file
        canvas.toBlob(
          blob => {
            const resizedFile = new File([blob], file.name, {
              type: file.type, // keeps the original format
              lastModified: Date.now()
            });
            handleUpload(resizedFile);
          },
          file.type, // ensures original format
          0.9 // quality for JPEG/WEBP (ignored for PNG)
        );
      };
    };

    reader.readAsDataURL(file);

    fileInputRef.current.value = "";
  };
  const handleUpload = async image => {
    const formData = new FormData();
    formData.append("image", image);

    try {
      const response = await Axios.post(
        `https://image-search.explorug.online/api/search/${window.InterfaceElements.CurrentUserID}`,

        formData,
        {
          headers: { "Content-Type": "multipart/form-data" }
        }
      );

      const data = response.data.results;
      const updatedData = data.map(item => ({
        ...item,
        fullPath: `Designs/${item.fullPath.replace(/\.png$/, ".ctf")}`
      }));

      // Process each design individually to prevent one bad file from breaking all
      const results = await Promise.allSettled(
        updatedData.map(async design => {
          try {
            const thumbnails = await AppProvider.getDesignThumbnails({ designs: [design] });
            return thumbnails[0]; // assuming it returns an array
          } catch (err) {
            console.warn("Skipping design due to error:", design.fullPath, err.message);
            return null;
          }
        })
      );
      const variationsPropsList = results
        .filter(r => r.status === "fulfilled" && r.value)
        .map(r => r.value);

      dispatchDesignList({
        type: designListActions.SET_SEARCH_BY_IMAGE,
        payload: variationsPropsList
      });
      setLoading(false);
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  return (
    <>
      <div
        className={classNames(
          "at-input-group",
          "at-search-bar",
          { focused: focused, hidden: hidden },
          className
        )}
      >
        <AtIcon icon="search" />

        <input
          ref={input}
          type="text"
          className="bp3-input at-input"
          placeholder={placeholder}
          onFocus={e => {
            e.target.select();
            if (e.target.value.length) setFocused(true);
          }}
          value={textToSearch}
          onChange={onInputChange}
        />
        <div className="action-btn">
          {focused && (
            <>
              <AtButton
                size="small"
                onClick={e => {
                  setFocused(false);
                  handleCancel(e);
                }}
                icon="close"
                minimal
              ></AtButton>
              {window.flags.showSearchByImage && <div className="verticalLine"></div>}
            </>
          )}

          {/* {window.flags.showSearchByImage && uiState.pageView != pageViews.FULL_PAGE_THUMB && ( */}
          {window.flags.showSearchByImage && (
            <>
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
              <AtButton
                icon="double-chevron-camera"
                onClick={handleButtonClick}
                minimal
                tooltip="Search by Image"
                size="small"
              />
            </>
          )}
        </div>
      </div>
    </>
  );
};

SearchBar.propTypes = {
  handleInputChange: PropTypes.func
};

export default SearchBar;
